import React from 'react';
import { useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { PostCall } from '../../../hooks/api/usePostCall';
import { Subheader } from '../post-call-form';
import { resolveTheme } from '../../../themes';

export interface FeedbackStepProps {
  postCall?: PostCall;
  className?: string;
}

export const FeedbackStep: React.FC<FeedbackStepProps> = ({ postCall, className }) => {
  const { register } = useFormContext();
  const theme = resolveTheme();

  return (
    <div className={twMerge('flex flex-col gap-6', className)}>
      <Subheader
        question={
          <>
            Is there any <span className="font-bold">feedback</span> you'd like to share with {theme.name}?
          </>
        }
        postCall={postCall}
      />

      <textarea
        {...register('feedback')}
        placeholder="Share your thoughts here..."
        className="border-input-border-gray text-label-gray placeholder:text-placeholder-gray focus:border-accent focus:ring-accent/20 min-h-[200px] w-full rounded-[12px] border bg-gray-50 p-4 font-['Albert_Sans'] text-base font-normal leading-6 focus:outline-none focus:ring-2"
      />
    </div>
  );
};
